import { Button, Center, Stack, Text, Title } from '@mantine/core'
import { IconArrowLeft, IconError404 } from '@tabler/icons-react'
import { useRouter } from '@tanstack/react-router'

export function NotFound() {
  const router = useRouter()

  return (
    <Center mih="100vh" p="xl">
      <Stack align="center" gap="lg" maw={420}>
        <IconError404 size={80} stroke={1.2} color="var(--mantine-color-dimmed)" />
        <Title order={2} ta="center">
          Halaman Tidak Ditemukan
        </Title>
        <Text c="dimmed" ta="center">
          Halaman yang Anda cari tidak tersedia atau telah dipindahkan.
        </Text>
        <Button variant="light" leftSection={<IconArrowLeft size={16} />} onClick={() => router.history.back()}>
          Kembali
        </Button>
      </Stack>
    </Center>
  )
}
